import { useTranslator } from '@Localization';
import { useInjection } from 'inversify-react';
import { checkUserPlan, IPermissionCheckResult } from '../../../modules/permissions/permissionsHelpers';
import { Plan } from '../user/user.store';
import { IWorkspacesStore } from '../workspaces/workspaces.store';

interface IIntegrationsPermissions {
  canViewIntegrations(): IPermissionCheckResult;
}

export const useIntegrationsPermissions = (): IIntegrationsPermissions => {
  const workspacesStore = useInjection(IWorkspacesStore.$);
  const { t } = useTranslator();

  const canViewIntegrations = (): IPermissionCheckResult => {
    const workspace = workspacesStore.workspaces.find((x) => x.role === 'Owner');

    if (!workspace) {
      return { allowed: false, reason: t('you_do_not_have_permission_to_perform_this_operation') };
    }
    return checkUserPlan([Plan.Admin, Plan.Annotation, Plan.Training, Plan.Inactive], workspace, t);
  };

  return {
    canViewIntegrations,
  };
};
